import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { StringFormatter } from '@repo/toolkit/string'
import { StarIcon, WalkingPersonIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'

import useTranslate from '../../../../lib/hooks/use-translate'
import { EnrollmentLight } from '../../../../lib/types/models/enrollment/enrollment-light'
import InformationToolTip from '../../../elements/information-tooltip'

type Props = {
  enrollment: EnrollmentLight
}

const OlCenterEnrollmentTableStudentInfo = ({ enrollment }: Props) => {
  const { t } = useTranslate()
  const canGoOutAlone = enrollment.parentAuthorizedToGoOutAlone === true

  return (
    <div className="flex items-center gap-10 ">
      <Typography variant="secondary-body">
        {enrollment.childFirstName ? StringFormatter.capitalize(enrollment.childFirstName) : '-'}
      </Typography>
      <div className="flex items-center gap-3 ">
        {canGoOutAlone && (
          <InformationToolTip
            contentVariant="secondary"
            align="center"
            icon={
              <div className="bg-grey-light rounded-full p-1 w-fit">
                <WalkingPersonIcon color={tailwindColors.grey.DEFAULT} />
              </div>
            }
            size="small"
          >
            <Typography variant={'label-medium'} color={tailwindColors.black.DEFAULT}>
              {t('ol.center.tooltip.canGoOutAlone')}
            </Typography>
          </InformationToolTip>
        )}
        {enrollment.isAA && (
          <div className="bg-yellow-light rounded-full p-1 w-fit">
            <StarIcon filled color={tailwindColors.yellow.DEFAULT} />
          </div>
        )}
      </div>
    </div>
  )
}

export default OlCenterEnrollmentTableStudentInfo
